import { HttpResponse, HttpService } from '@application/http.service';
import { CreateMessageConversationResult } from '@visiba/api-vcs-guest';
import { Injectable } from '@visiba/instantiation';
import { ApiBaseGuest } from './_api_base_guest';

@Injectable()
export class GuestMessagingApiService extends ApiBaseGuest {
	constructor(private readonly httpService: HttpService) {
		super('messaging');
	}
	public create(receptionId: number, displayName: string, reason: string): HttpResponse<CreateMessageConversationResult> {
		return this.httpService.post(`${this.baseUri}/${receptionId}`, {
			displayName,
			reason,
		});
	}
}
